<template>
  <div class="period-selection-container">
    <label class="color-black font-18 mt-1 mr-3">Periodo:</label>
    <div
      class="period-selection-container__section"
      :class="[{ finalized: this.completedPeriod }]"
    >
      <div
        v-for="(p, index) in getPeriods"
        :key="'period-selection' + index"
        class="period-selection-container__period"
        :class="[
          {
            disabled:
              (p.disabled && !p.completed && !p.active) ||
              evalDisabledRegularPeriod(p.id),
            completed: p.completed,
            active: p.active && !p.completed,
          },
        ]"
        @click="onSelectPeriodHandler(p)"
      >
        <span class="d-block color-gray-7 font-14 font-weight-bold">
          {{ p.month }}
        </span>
        <span class="color-gray-7 font-14">
          {{ p.year }}
        </span>
        <div v-if="p.completed" class="period-finish">
          <div
            v-if="p.completed"
            class="dot cursor-pointer green"
            @click="extraExpanded = !extraExpanded"
          >
            <em class="title-icon fa fa-check" />
          </div>
          <span>Periodo Finalizado</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import 'moment/locale/es-do';
import REQUEST_TYPES from '@/utils/constants/compensatoryRequestTypes';

const MONTH_FORMAT = 'MMM';
const YEAR_FORMAT = 'YYYY';

export default {
  name: 'PeriodSelection',
  props: {
    currentPeriod: {
      type: Date,
      required: true,
    },
    initialPeriod: {
      type: Date,
      required: true,
    },
    disabledPeriods: {
      type: Array,
      default: () => [],
    },
    completedPeriod: {
      type: Date,
      default: () => null,
    },
    disabledRegularPeriod: {
      type: Boolean,
      default: () => true,
    },
  },
  data: () => ({
    currentPeriodModel: null,
    compensatoryInfo: {},
  }),
  computed: {
    getPeriods() {
      const initialPeriod = moment().set({
        year: this.initialPeriod.getFullYear(),
        month: this.disabledRegularPeriod ? 6 : 5,
      });
      const periods = [];
      let months =
        this.compensatoryInfo != null &&
        this.compensatoryInfo.requestTypeId == REQUEST_TYPES.Reposicion
          ? 13
          : 12;
      for (let index = 1; index <= months; index++) {
        const p = moment(initialPeriod).add(index, 'month');
        periods.push({
          id: index,
          date: p,
          period: {
            year: p.year(),
            monthNumber: p.month() + 1,
          },
          month: p.format(MONTH_FORMAT).toUpperCase(),
          year: p.format(YEAR_FORMAT),
          active:
            this.formatDateToEval(
              moment(this.currentPeriodModel || this.currentPeriod)
            ) == this.formatDateToEval(p),
          disabled: this.isDisabled(p, index),
          completed:
            this.formatDateToEval(moment(this.completedPeriod)) ==
            this.formatDateToEval(p),
        });
      }
      return periods;
    },
    disabledPeriodsFormatted() {
      return this.disabledPeriods.map((s) => this.formatDateToEval(s));
    },
  },
  watch: {
    currentPeriod() {
      this.currentPeriodModel = this.currentPeriod;
    },
  },
  mounted() {
    const visitInfo = this.$route.params;
    if (visitInfo) {
      this.compensatoryInfo = visitInfo.compensatoryInfo;
    }
  },
  methods: {
    formatDateToEval(value) {
      return moment(value).format(`${MONTH_FORMAT} ${YEAR_FORMAT}`);
    },
    isDisabled(period, id) {
      if (this.disabledRegularPeriod) {
        return this.evalDisabledRegularPeriod(id);
      } else {
        return this.disabledPeriodsFormatted.includes(
          this.formatDateToEval(period)
        );
      }
    },
    onSelectPeriodHandler({ disabled, period }) {
      if (this.disabledPeriods && disabled) {
        return;
      }
      this.$emit('input', period);
    },
    evalDisabledRegularPeriod(id) {
      if (this.disabledRegularPeriod) {
        return ![13, 12, 11].includes(id); //only keep june and july and august
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';

.period-selection-container {
  display: flex;
  justify-content: center;
  align-items: center;
  &__section {
    display: flex;
    flex-flow: row wrap;
    flex: 1;
  }
  &__period {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    align-items: center;
    span {
      user-select: none;
    }
    span:last-child {
      margin-top: -4px;
    }
    &.active {
      padding: 2px 0px;
      background: map-get($colors, 'orange');
      span {
        color: map-get($colors, 'white') !important;
      }
      border-radius: 20px;
    }
    &.disabled {
      span {
        color: map-get($colors, 'gray-2') !important;
      }
    }
    &.completed {
      padding: 2px 0px;
      background: map-get($colors, 'orange') !important;
      span {
        color: map-get($colors, 'white') !important;
      }
      border-radius: 20px;
      .period-finish {
        background: map-get($colors, 'green');
        color: map-get($colors, 'white');
        border-radius: 50px;
        position: absolute;
        bottom: -29px;
        padding: 0px 22px;
        span {
          font-size: 12px;
        }
      }
    }
  }
}

.finalized {
  .period-selection-container__period:not(.completed) {
    span {
      color: map-get($colors, 'black');
    }
  }
}

.dot {
  box-shadow: 0px 3px 6px #00000029;
  margin: 2px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border-style: solid;
  border-width: 1px;
  display: inline-block;
  margin-right: 15px;
  position: absolute;
  left: 15px;
  top: -25px;
}

.title-icon {
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 3px;
}

.dot.green {
  background-color: #2db782;
}
</style>
